<template>
	<div class="popup_wrpr app_settings_popup_wrpr active">
		<div class="app_settings_popup" :class="{right_open: showRightPanel}">
			<div class="popup_left_side">
				<Loading v-show="loading"/>
				<a class="close_popup_btn" @click.prevent="closePopup">
					<inline-svg :src="require('@/assets/img/popup_close.svg')"/>
				</a>
				<a class="right_toggle" :class="{active: showRightPanel}" @click.prevent="showRightPanel = !showRightPanel">
					<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
						<path fill-rule="evenodd" clip-rule="evenodd" d="M6.96124 8.03874L6.37208 8.6279L2.74416 4.99999L6.37208 1.37207L6.96124 1.96124L3.92249 4.99999L6.96124 8.03874Z" fill="#E4E6F1"></path>
					</svg>
				</a>
				<div class=" funnel-app-settings noscroll layout-column">
<!--					<h3 class="popup_title">Funnel app settings</h3>-->

					<div class="funnel_app_item" style="margin-right: 25px">
						<div class="left">
							<div class="img_wrpr">
								<img v-if="thisApp['image-url']" :src="thisApp['image-url']">
								<img v-else :src="'data:image/png;base64,' + thisApp.image">
							</div>
							<div class="text_content ">
								<h3>{{thisApp.name}}
									<div class="info_btn" @click="showRightPanel = !showRightPanel">
										<span>Help</span>
										<inline-svg :src="require('@/assets/img/info_icon.svg')"/>
									</div>
								</h3>
								<p>{{thisApp.description}}</p>
							</div>
						</div>
						<div class="layout-column flex-center on-button">
							<v-switch no-label v-model="appData.active" :value="appData.active" />
							<span v-if="appData.active" class="active">ACTIVE</span>
							<span v-else class="inactive" content="App is inactive!"
							      v-tippy='{ arrow : true, showOnInit:true,distance:15,interactive:true,delay:1000,theme:"red",sticky: true,hideOnClick:false,placement:"bottom" }'>INACTIVE</span>
						</div>
					</div>


					<div class="scroll layout-column work-area" style="">

						<!-- v-show="appData.active"-->
						<component v-if="thisAppFromFile" :is="appName" :funnel="funnel" :appId="app.data.id" :user-app="thisApp"
						           :dataBufferObject="this.dataBufferObject" @update="updateConfig"/>

						<template v-else-if="!thisAppFromFile && (typeof newDataConfig === 'array' || typeof newDataConfig === 'object')">
							<div class="brdr_box_w_checkbox" v-for="(item, index) in newDataConfig" :key="index">

								<template v-if="item.type === 'helpbox'">
									<div class="right w100 helpbox">
										<h3>{{ item.title }}</h3>
										<div v-html="item.body"></div>
										<ul>
											<li v-for="(link, linDex) in item.links" :key="linDex">
												<a :href="link.url" target="_blank">{{ link.title }}</a>
											</li>
										</ul>
									</div>
								</template>

								<template v-if="item.type === 'note'">
									<div v-html="item.html" class="right w100 note"></div>
								</template>

								<template v-if="item.type === 'string' || item.type === 'text' || !item.type">
									<InputField :label="item.caption" v-model="dataBufferObject[item.name]"></InputField>
								</template>

								<template v-if="item.type === 'range'">
									<InputField :label="item.caption" v-model="dataBufferObject[item.name]" type="number" min="1" max="60" step="2"></InputField>
								</template>

								<template  v-if="item.type === 'select'">
									<div class="right w100">
										<h3>{{item.caption}}</h3>
										<Select2 v-model="dataBufferObject[item.name]" :options="item.options" :settings="{dropdownAutoWidth: true, width: '100%'}" />
									</div>
								</template>

								<template  v-if="item.type === 'multi-select'">
									<div class="right w100">
										<h3>{{item.caption}}</h3>
										<Select2 v-model="dataBufferObject[item.name]" :options="item.options" :settings="{dropdownAutoWidth: true, width: '100%', multiple: true}" />
									</div>
								</template>

								<template v-if="item.type === 'boolean'">
									<label class="switch_checkbox_item">
										<input type="checkbox" v-model="dataBufferObject[item.name]">
										<div class="switch_checkbox"><span></span></div>
									</label>

									<h3>{{item.caption}}
										<div class="info_btn" v-if="item.hint">
											<inline-svg :src="require('@/assets/img/info_icon.svg')"/>
											<div class="tooltip">{{item.hint}}</div>
										</div>
									</h3>
								</template>

							</div>
						</template>

						<div class="settings-hide-msg funnel_app_item" style="display: block;cursor: inherit"
						     v-if="!newDataConfig || Object.keys(newDataConfig).length===0">
							This app does not require any configuration at the funnel level,
							Check
							<div class="info_btn" style="display: inline-flex;margin-left: 0;" @click="showRightPanel = !showRightPanel">
								<span>Help</span>
								<inline-svg :src="require('@/assets/img/info_icon.svg')"/>
							</div>
							for further details on how it works.
						</div>

					</div>
				</div>

				<div class="bottom_btns_wrpr">
					<a @click="closePopup" class="btn brdr_btn">Cancel</a>
					<v-button :loading="saving" @click="saveApps" label="Save changes" />
				</div>
			</div>
			<div class="popup_right_side">
				<funnel-app-preview v-show="showRightPanel" :app="thisApp" :newUserApp="dataBufferObject" :user-app="newData"></funnel-app-preview>
			</div>

		</div>
	</div>
</template>

<script>
import Loading from "@/components/Loading.vue"
import API from "@/api"
import countries from "@/helpers/countries"

import FunnelAppPreview from "@/views/funnels/apps/preview/app_preview";
import InputField from "@/components/base/input-field";

import Empty from "@/views/funnels/apps/funnel-apps/Empty.vue"
import FbPixelSettings from "@/views/funnels/apps/funnel-apps/fb-pixel-settings.vue"
import FpaySettings from "@/views/funnels/apps/funnel-apps/fpay-settings.vue"
import PaypalAppV2 from "@/views/funnels/apps/funnel-apps/paypal-app-v2.vue"
import PaypalPluginSettings from "@/views/funnels/apps/funnel-apps/paypal-plugin-settings.vue"
import SmartAddressSettings from "@/views/funnels/apps/funnel-apps/smart-address-settings.vue"
import SmartCurrencySettings from "@/views/funnels/apps/funnel-apps/smart-currency-settings.vue"
import VButton from "@/components/base/v-button";
import ProofySettings from '@/views/funnels/apps/funnel-apps/proofy-settings';
import TaxjarSettings from "@/views/funnels/apps/funnel-apps/taxjar/taxjar-settings";
import TiktokPixel from "@/views/funnels/apps/funnel-apps/tiktok-pixel";
import VSwitch from "@/components/base/v-switch";

export default {
	name: "AppSettingsPopup",
	components: {
		VSwitch,
		TaxjarSettings,
		VButton,
		InputField,
		FunnelAppPreview, Loading,
		ProofySettings,
		TiktokPixel,
		Empty, FbPixelSettings, FpaySettings, PaypalAppV2, PaypalPluginSettings, SmartAddressSettings, SmartCurrencySettings,
	},
	mixins: [API],
	props:['funnel'],
	data() {
		return {
			app: {},
			type: 'funnel',
			loading: true,
			showRightPanel: false,
			selectValue: '',
			settingsToggle: true,
			thisApp: {
				image: '',
				name: '',
				description: '',
			},
			appData: {},
			howto: {},
			config: [],
			newDataConfig: {},
			newData: {},
			paymentMethodData: {},
			showMethods: false,
			showMethodDetails: [],
			gatewaysPopup: false,
			countries: countries,
			thisAppFromFile: false,
			dataBufferObject: {},
			saving: false,
		}
	},
	computed: {
		appName() {
			return this.newDataConfig[0].src ? this.newDataConfig[0].src.split('/')[1] : 'Empty'
		}
	},
	methods: {
		updateConfig(ev, field, child = false) {
			if(child) {
				this.dataBufferObject[field][child] = ev;
			} else {
				this.dataBufferObject[field] = ev;
			}
		},
		testMe(itemName, option) {
			this.newDataConfig[itemName] = {}
			this.newDataConfig[itemName][option] = '';
		},
		closePopup() {
			this.$router.push({path: `/wfunnel/${this.$route.params.id}/apps`});
		},
		async saveApps() {
			try {
				this.saving = true;
				this.newData = {
					app_id: parseInt(this.$route.params.appId),
					funnel_id: parseInt(this.$route.params.id),
					active: this.appData.active,
					config: JSON.stringify(this.dataBufferObject),
				};
				let result = await this.api.apps.patchFunnelApp(this.newData.funnel_id, this.newData, true);
				this.$emit('update', result);
				this.closePopup();
			}catch (e) {
				this.$notify({
					type: "warn",
					group: "main",
					title: "Something went wrong... Please try again later",
				});
				console.error("error", e);
			} finally {
				this.saving = false;
			}
		},
		async init() {
			this.$store.commit("showSettingsPopup");

			var appsRes = await this.getFilteredApps(this.$route.params.id, this.$route.params.appId);
			this.app = appsRes.data;

			this.appData = appsRes.data.data.attributes;
			this.newData = this.app.data;

			this.thisApp = this.app.included.find(item=>item.type === 'apps').attributes
			this.config = this.thisApp.config.length ? JSON.parse(this.thisApp.config) : [];

			this.newDataConfig = this.thisApp['funnel-config'] ? JSON.parse(this.thisApp['funnel-config']) : {};

			if (this.newDataConfig.length > 0) {
				if (this.newDataConfig[0] !== undefined && this.newDataConfig[0].type !== 'file') {
					this.dataBufferObject = this.appData.config.length ? JSON.parse(this.appData.config) : {};
				}

				if(this.newDataConfig[0] == undefined || this.newDataConfig[0].type === 'file') {
					this.thisAppFromFile = true;

					this.dataBufferObject = this.app.data.attributes.config ? JSON.parse(this.app.data.attributes.config) : {}
				}
			}

			this.$nextTick(()=>this.loading = false);
			appsRes = null;
		}
	},
	mounted() {
		this.init();
	}
}
</script>
<style lang="scss" scoped>
.on-button {
	.active {
		color: $dark-grey;
	}
	.inactive {
		color: red;
	}
}
</style>
